import NotificationsDropdownMobile from './NotificationsDropdownMobile';
import NotificationsDropdownMobileExperimental from './NotificationsDropdownMobile.experimental_body_scroll_lock';
import { withFeatureBranch } from '../../../redux/flags';
export default withFeatureBranch({
    experimental_body_scroll_lock: NotificationsDropdownMobileExperimental,
})(NotificationsDropdownMobile);
//# sourceMappingURL=index.js.map